import React, {useEffect, useState, useRef, RefObject} from "react";
import {useNavigate,useParams, useSearchParams, useOutletContext} from "react-router-dom";
import {Button, Card, Col, Divider, Progress, Row, Grid} from "antd";
import {fetchEvaluateAction, resetEvaluateAction, RootState, selectStore} from "../../../../../../utils";
import {useDispatch, useSelector} from "react-redux";
import {
  fetchScreeningRoutinesListAction,
  postScreeningEarlyQuestionsListAction, postScreeningOneEarlyTestAction
} from "../../../../../../utils/store/pages/screening";
import {MyButton, MyText} from "../../../../../../components";
import {CheckOutlined, LeftOutlined} from "@ant-design/icons";
import {ButtonContainer} from "../../../../../MaterialsDetail/style";
import {useTranslation} from "react-i18next";
import { useEmbeddedNavigate } from "../../../../../../utils/context/embed";

type ContextType = {
  contentRef: RefObject<HTMLDivElement>;
};


export const TestNeuroProcessingPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
    const {t} = useTranslation("common")
const embeddedNavigate = useEmbeddedNavigate();

  const { ageId, testId, childId } = useParams();
    const {name} = useParams();
    const { useBreakpoint } = Grid;
    const screens = useBreakpoint();
  const [searchParams] = useSearchParams();

  const [answers, setAnswers] = useState<Record<number, number>>({});
  const [groupedQuestions, setGroupedQuestions] = useState<any[]>([]);
  const [currentBlockIndex, setCurrentBlockIndex] = useState<number>(0);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState<number>(0);
  const [testCompleted, setTestCompleted] = useState<boolean>(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const evaluate = useSelector((state: any) => state.materials?.evaluate ?? { loading: false });

  const {
    screening: {
      surveysList: surveysListState,
      earlyQuestionList: earlyQuestionListState
    }
  }: RootState = useSelector(selectStore);

  // const routesIdx = searchParams.get("routesIdx");

  // const parsedRoutesIdx = JSON.parse(routesIdx);

  const { contentRef } = useOutletContext<ContextType>();
  const isTablet = screens.md && !screens.xl && !screens.xxl;

  const scrollToTop = () => {
    contentRef?.current?.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    if (ageId) {
      dispatch(postScreeningEarlyQuestionsListAction({ survey_ids: [], age: Number(ageId) * 12, list_id: 3  }));
    }
  }, [ageId]);

  useEffect(() => {
    if (ageId) {
      dispatch(fetchScreeningRoutinesListAction({ age: Number(ageId) * 12 , list_id: 3 }));
    }
  }, [ageId]);

  const handleFinishTesting = () => {
    const body = {
      test_id: testId,
      child_id: childId,
      answers: Object.entries(answers).map(([questionId, answerId]) => ({
        question_id: Number(questionId),
        answer_id: answerId,
      })),
    };
    dispatch(fetchEvaluateAction(body));
  };

  useEffect(() => {
    if (!evaluate.success || !evaluate.data?.user_test_id) return;
      embeddedNavigate(`/results/testId/${evaluate.data.user_test_id}/type/3`);
    }, [evaluate.success, evaluate.data]);

  useEffect(() => {
    if (earlyQuestionListState.data && surveysListState.data) {

      if (!surveysListState?.data?.surveys || !earlyQuestionListState?.data) {
        return;
      }

      const grouped = surveysListState?.data?.surveys.map((OneSurvey: any) => {

        const survey = surveysListState?.data?.surveys?.find((s: any) => s.id === OneSurvey?.id);
        const questions = earlyQuestionListState?.data?.filter((q: any) => q.survey_id === OneSurvey?.id);
        return {
          surveyId:OneSurvey?.id,
          surveyName: survey?.name,
          surveyCount: survey?.count,
          questions,
        };
      });

      // const surveys = surveysListState?.data?.surveys || [];
      // const questions = earlyQuestionListState?.data;
  
      // const grouped = surveys.map((survey) => ({
      //   surveyId: survey.id,
      //   surveyName: survey.name,
      //   surveyCount: survey.count,
      //   questions,
      // }));
  
      setGroupedQuestions(grouped);
    }
  }, [earlyQuestionListState.data, surveysListState.data]);

  if (!groupedQuestions.length) {
    return null;
  }

  const currentBlock = groupedQuestions[currentBlockIndex];
  const currentQuestion = currentBlock.questions[currentQuestionIndex];
  const isCurrentBlockCompleted = currentBlock.questions.every((q: any) => answers[q.id] !== undefined);

  const totalQuestions = groupedQuestions.reduce((sum, block) => sum + block.questions.length, 0);
  const answeredQuestions = Object.keys(answers).length;
  const overallProgress = Math.round((answeredQuestions / totalQuestions) * 100);

  const handleAnswerSelect = (questionId: number, answerId: number) => {
    setAnswers((prevAnswers) => ({
      ...prevAnswers,
      [questionId]: answerId,
    }));

    const currentBlock = groupedQuestions[currentBlockIndex];
    const isCurrentBlockCompleted = currentBlock?.questions?.every((q: any) => answers[q.id] !== undefined);

    if (!isCurrentBlockCompleted) {
      if (currentQuestionIndex + 1 < currentBlock?.questions?.length) {
        setCurrentQuestionIndex(currentQuestionIndex + 1);
      } else {
        if (currentBlockIndex + 1 < groupedQuestions.length) {
          setCurrentBlockIndex(currentBlockIndex + 1);
          setCurrentQuestionIndex(0);
          scrollToTop();
        } else {
          setTestCompleted(true);
        }
      }
    }
  };

  const handleGoBack = () => {
    embeddedNavigate(-1);
  };

  const getYearLabel = (age: any) => {
    const lastDigit = age % 10;
    const lastTwoDigits = age % 100;
  
    if (lastTwoDigits >= 11 && lastTwoDigits <= 14) return t("ages2");
    if (lastDigit === 1) return t("ages1");
    if (lastDigit >= 2 && lastDigit <= 4) return t("ages");
    return t("ages2");
  };

  // const handleFinishTesting = async () => {
  //   const formattedAnswers = Object.entries(answers).map(([questionId, answerId]) => ({
  //     question_id: Number(questionId),
  //     answer_id: answerId,
  //   }));
  
  //   const body = {
  //     test_id: testId,
  //     // age: Number(ageId) * 12,
  //     // name: name,
  //     child_id: childId,
  //     answers: formattedAnswers,
  //   };
  
  //   try {
  //     // await dispatch(postScreeningOneEarlyTestAction(body));
  
  //     // const response = await fetchTestResults(3);
  //     // if (response && response.results && response.results.length > 0) {
  //     //   const testId = response.results[0].test_id;
  //     //   navigate(`/results/testId/${testId}/type/3`);
  //     // } else {
  //     //   console.error("Список результатов пуст.");
  //     // }

  //     const response = await fetchEvaluate(body);
  //           if (response && response.user_test_id) {
  //             const testId = response.user_test_id;
  //             embeddedNavigate(`/results/testId/${testId}/type/3`);
  //           } else {
  //             console.error("Список результатов пуст.");
  //           }
  //   } catch (error) {
  //     console.error("Ошибка при завершении тестирования:", error);
  //   }
  // };
  const activeBlock = groupedQuestions[currentBlockIndex];

  return (
    <>
      <Row justify="center">
        <Col span={20}>
          <Row gutter={[32,30]}>
            <Col span={24}>
            <Row align="middle" justify="space-between" style={{ padding: '0px', height: screens.xs || isTablet ? 'auto' : '60px' }}>
              {screens.xs || isTablet ? (
                <>
                  <Col span={24} style={{marginBottom: 12}}>
                                          
                    <Row align="middle">
                      <Col span={3}>
                      <ButtonContainer onClick={handleGoBack}>
                        <LeftOutlined style={{ color: 'rgba(10, 3, 60, 0.7)' }} />
                          </ButtonContainer>
                              </Col>
                              <Col span={21}>
                         <MyText
                          color="rgba(19, 15, 38, 1)"
                              size={26}
                                  weight={800}
                                  style={{ fontFamily: 'Nunito', display: 'block', marginLeft: 12 }}
                                    >
                                Нейропсихология
                              </MyText>
                            </Col>
                                            </Row>
                                            </Col>
                                                                    
                                            <Row style={{ background: '#fff', borderRadius: '16px', padding: '10px 16px', border: '1px solid rgba(229, 233, 242, 1)' }}>
                                                              <MyText color="rgba(10, 3, 60, 1)" weight={700} size={32} style={{ fontFamily: 'Nunito', lineHeight: '40px' }}>
                                                              {`${ageId} ${getYearLabel(ageId)}`}
                                                              </MyText>
                                                            </Row>
                                            </>
                                          ) : (
                                            <>         
                                            <Row align="middle">
                            
                                                                        <ButtonContainer onClick={handleGoBack}>
                                                                          <LeftOutlined style={{ color: 'rgba(10, 3, 60, 0.7)' }} />
                                                                        </ButtonContainer>
                                                                        <MyText
                                                                          color="rgba(19, 15, 38, 1)"
                                                                          size={32}
                                                                          weight={800}
                                                                          style={{ fontFamily: 'Nunito', display: 'block', marginLeft: 12 }}
                                                                        >
                                                                          Нейропсихология
                                                                        </MyText>
                                            </Row>
                                                                    
                                            <Row style={{ background: '#fff', borderRadius: '16px', padding: '10px 16px', border: '1px solid rgba(229, 233, 242, 1)' }}>
                                                              <MyText color="rgba(10, 3, 60, 1)" weight={700} size={32} style={{ fontFamily: 'Nunito', lineHeight: '40px' }}>
                                                              {`${ageId} ${getYearLabel(ageId)}`}
                                                              </MyText>
                                                            </Row>
                                            </>
                                          )}
            </Row>
            </Col>
          

          {screens.xs && (
              <Col span={24}>
              <Card style={{height: "100%", borderRadius: "20px"}}>
                <Row justify="space-between">
                  <MyText size={17} weight={600} lineHeight="21px" color="rgba(35, 28, 80, 1)">{currentBlockIndex + 1} блок</MyText>
                  <MyText size={16} weight={600} lineHeight="21px" color="rgba(10, 3, 60, 1)">{overallProgress}%</MyText>
                </Row>
                <Progress percent={overallProgress} strokeColor="#FF9500" showInfo={false}/>
                <MyText size={16} color="#68727D">{`${t("task")}`} {currentQuestionIndex + 1} из {currentBlock?.questions?.length}</MyText>

                <Divider style={{marginBottom: 16, marginTop: 16}}/>

                <Row
                                  justify="start"
                                  style={{
                                    display: 'flex',
                                    overflowX: 'auto',
                                    paddingBottom: 10,
                                    gap: 16
                                  }}
                                >
                  {groupedQuestions.map((block: any, index: number) => {
                    const isActiveBlock = index === currentBlockIndex;
                    const isCompleted = block?.questions?.every((q: any) => answers[q.id] !== undefined);
                    const blockNumber = index + 1;
                    const activeBlock = groupedQuestions[currentBlockIndex];

                    return (
                      <Row
                        key={block.surveyId}
                        onClick={() => {
                          setCurrentBlockIndex(index);

                          if (isCompleted) {
                            setCurrentQuestionIndex(0);

                          } else {
                            const firstUnansweredQuestionIndex = block?.questions?.findIndex(
                              (q: any) => answers[q.id] === undefined
                            );
                            setCurrentQuestionIndex(
                              firstUnansweredQuestionIndex !== -1 ? firstUnansweredQuestionIndex : 0
                            );
                          }
                          scrollToTop();
                        }}
                        style={{marginBottom: 16, cursor: 'pointer' }}
                      >
                        <div
                          style={{
                            width: 32,
                            height: 32,
                            borderRadius: '50%',
                            backgroundColor: isActiveBlock ? '#00BDF4' : '#F4F5F7',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          {isCompleted ? (
                            <CheckOutlined style={{color: isActiveBlock ? '#FFFFFF' : '#00BDF4'}}/>
                          ) : (
                            <MyText weight={700} lineHeight="20px" color={isActiveBlock ? '#FFFFFF' : '#68727D'}>{blockNumber}</MyText>
                          )}
                        </div>
                      </Row>
                    );
                  })}
                </Row>
                <MyText size={18} lineHeight="32px" color='#00BDF4'>
                          {activeBlock.surveyName} ({activeBlock?.questions?.length})
                </MyText>
                {testCompleted && (
                  <Row justify="center">
                    <MyButton color="orange" type="primary" onClick={handleFinishTesting} style={{marginTop: 16}}>
                      {`${t("finishTest")}`}
                    </MyButton>
                  </Row>
                )}
              </Card>
            </Col>
          )}
            <Col span={screens.xs ? 24 : 17}>
              <Card style={{ height: "100%", borderRadius: "20px" }}>
                  <>
                    <Row justify="space-between">
                      <MyText size={18} weight={600} lineHeight= {screens.xs ? "26px" : "32px"} color="rgba(104, 114, 125, 1)">
                      {t("task")} {currentBlockIndex + 1}. {currentBlock?.surveyName}
                      </MyText>
                      {!isCurrentBlockCompleted && (
                        <MyText size={18} weight={700} lineHeight="32px" color="rgba(10, 3, 60, 1)">
                          {`${t("test")}`} {currentQuestionIndex + 1}/{currentBlock?.questions?.length}
                        </MyText>
                      )}
                    </Row>

                    <Divider style={{ marginBottom: 16, marginTop: 16 }} />
                    {/* <MyText size={24} weight={400} lineHeight="24px" color="rgba(10, 3, 60, 1)">
                          Подготовьте несколько пар одинаковых картинок
                        </MyText> */}
                    {/* {isCurrentBlockCompleted ? ( */}
                      <>
                        {currentBlock?.questions?.map((question: any, index: number) => (
                          <Row key={question.id} style={{ marginBottom: 24, marginTop: 24, flexDirection: "column", }}>

                          {/* <Row key={question.id} justify="center" align="middle" style={{ marginBottom: 24, marginTop: 24, flexDirection: "column", }}> */}
                          <MyText style={{textAlign: "left", fontFamily: 'Nunito', marginBottom: 24}} 
                            size={22} weight={800} 
                            lineHeight={screens.xs ? "22px" : "26px"} 
                            color="rgba(19, 15, 38, 1)">
                            {`${t("test")}`} {index + 1}.
                          </MyText>
                          <Row>
                          <MyText style={{textAlign: "left", fontFamily: 'Nunito', marginBottom: 24}} 
                            size={22} weight={600} 
                            lineHeight={screens.xs ? "22px" : "26px"} 
                            color="rgba(19, 15, 38, 1)">
                          <div dangerouslySetInnerHTML={{ __html: question.text }} />
                          </MyText>
                          </Row>
                          
                            <Row justify="center" gutter={[16, 16]}>
                              {question?.answers?.map((answer: any) => (
                                <MyButton
                                  key={answer.id}
                                  onClick={() => handleAnswerSelect(question.id, answer.id)}
                                  style={{
                                    backgroundColor:
                                      answers[question.id] === answer.id ? "#00BDF4" : "#E7FAFF",
                                    color: answers[question.id] === answer.id ? "#FFFFFF" : "#008DD2",
                                    border: "none",
                                    borderRadius: "8px",
                                    marginLeft: 6,
                                    marginRight: 6
                                  }}
                                >
                                {answer.text.replace(/<\/?p>/g, " ")}
                                </MyButton>
                              ))}
                            </Row>
                          </Row>
                        ))}
                      </>
                    {/* ) : (
                      <>
                      <Col span={24}>
                      <Row justify="center">
                          <MyText size={screens.xs ? 26 : 32} weight={800} lineHeight={screens.xs ? "36px" : "48px"} color="#130F26" style={{textAlign: "center", fontFamily: 'Nunito'}}>{currentQuestion.text}</MyText>
                        </Row>
                      </Col>
                        

                        <Row justify="center" gutter={[32, 32]} style={{marginTop: 32}}>
                          {currentQuestion?.answers?.map((answer: any) => (
                            <MyButton
                              key={answer.id}
                              onClick={() => handleAnswerSelect(currentQuestion.id, answer.id)}
                              style={{
                                backgroundColor:
                                  answers[currentQuestion.id] === answer.id ? "#00BDF4" : "#E7FAFF",
                                color: answers[currentQuestion.id] === answer.id ? "#FFFFFF" : "#008DD2",
                                border: "none",
                                borderRadius: "8px",
                                marginLeft: 6,
                                marginRight: 6
                              }}
                            >
                              {answer.text}
                            </MyButton>
                          ))}
                        </Row>
                      </>
                    )} */}
                  </>
              </Card>
            </Col>

            {screens.xs ? null : (
            <Col span={7}>
              <Card style={{height: "100%", borderRadius: "20px"}}>
                <Row justify="space-between">
                  <MyText size={17} weight={600} lineHeight="21px" color="rgba(35, 28, 80, 1)">{currentBlockIndex + 1} блок</MyText>
                  <MyText size={16} weight={600} lineHeight="21px" color="rgba(10, 3, 60, 1)">{overallProgress}%</MyText>
                </Row>
                <Progress percent={overallProgress} strokeColor="#FF9500" showInfo={false}/>
                <MyText size={16} color="#68727D">{`${t("task")}`} {currentQuestionIndex + 1} из {currentBlock?.questions?.length}</MyText>

                <Divider style={{marginBottom: 16, marginTop: 16}}/>


                <Row style={{flexDirection: "column"}}>
                  {groupedQuestions.map((block: any, index: number) => {
                    const isActiveBlock = index === currentBlockIndex;
                    const isCompleted = block?.questions?.every((q: any) => answers[q.id] !== undefined);
                    const blockNumber = index + 1;

                    return (
                      <Row
                        key={block.surveyId}
                        align="middle"
                        onClick={() => {
                          setCurrentBlockIndex(index);
                          scrollToTop();
                          if (isCompleted) {
                            setCurrentQuestionIndex(0);
                          } else {
                            const firstUnansweredQuestionIndex = block?.questions?.findIndex(
                              (q: any) => answers[q.id] === undefined
                            );
                            setCurrentQuestionIndex(
                              firstUnansweredQuestionIndex !== -1 ? firstUnansweredQuestionIndex : 0
                            );
                          }
                        }}
                        style={{marginBottom: 16, cursor: 'pointer', alignItems: 'cente' }}
                      >
                        <Col span={2}>
                        
                        <div
                          style={{
                            width: 32,
                            height: 32,
                            borderRadius: '50%',
                            backgroundColor: isActiveBlock ? '#00BDF4' : '#F4F5F7',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          {isCompleted ? (
                            <CheckOutlined style={{color: isActiveBlock ? '#FFFFFF' : '#00BDF4'}}/>
                          ) : (
                            <MyText weight={700} lineHeight="20px" color={isActiveBlock ? '#FFFFFF' : '#68727D'}>{blockNumber}</MyText>
                          )}
                        </div>
                        </Col>
                          <Col span={20} style={{marginLeft: 16}}>
                          
                        <MyText size={18} lineHeight="32px" color={isActiveBlock ? '#00BDF4' : '#130F26'} style={{ ...(isTablet && { flex: 1 })}}>
                          {block.surveyName} ({block?.questions?.length})
                        </MyText>
                        </Col>

                      </Row>
                    );
                  })}
                </Row>

                {testCompleted && (
                  <Row justify="center">
                    <MyButton color="orange" type="primary" onClick={handleFinishTesting} style={{
                      marginTop: 16,
                      ...(isTablet ? { whiteSpace: 'normal' } : {})
                    }}>
                      {`${t("finishTest")}`}
                    </MyButton>
                  </Row>
                )}
              </Card>
            </Col>
            )}
          </Row>
        </Col>
      </Row>
    </>
  );
};